import { DateTime } from 'luxon';

type Format =
  | 'dd/MM/yyyy'
  | 'dd/MM/yyyy • HH:mm'
  | 'dd/MM/yyyy • HH:mm:ss'
  | 'HH:mm'
  | 'HH:mm:ss';

/**
 * Format Date UTC String
 * @Att expect string format as: YYYY-MM-DDThh:mm:ss.000Z
 * @param date string
 * @example
 * const date = '2022-01-12T14:25:28.103Z';
 * const today = formatDateTimezone(date, 'dd/MM/yyyy • hh:mm:ss');
 * today => 12/01/2022 • 14:25:28
 * @returns formatted date timezone basead on the format provided
 */
export const formatDateTimezone = (date: string | number, format: Format) => {
  if (!date && typeof date !== 'number') return date;
  if (typeof date === 'number') {
    return DateTime.fromMillis(date).toFormat(format);
  }
  if (typeof date !== 'string') return '';
  if (!Number.isNaN(Number(date)) && date.trim() !== '') {
    return DateTime.fromMillis(Number(date))
      .toFormat(format)
      .toString();
  }
  if (!date.includes('T') || !date.endsWith('Z')) return date;
  return DateTime.fromISO(date).toFormat(format);
};
